"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var GitCommit = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "git-commit" },
            react_1.default.createElement("path", { id: "Icon", d: "M2.00018 11C1.4479 11 1.00018 11.4477 1.00018 12C1.00018 12.5523 1.4479 13 2.00018 13V11ZM22 13C22.5523 13 23 12.5523 23 12C23 11.4477 22.5523 11 22 11V13ZM15 12C15 13.6569 13.6568 15 12 15V17C14.7614 17 17 14.7614 17 12H15ZM12 15C10.3431 15 8.99999 13.6569 8.99999 12H6.99999C6.99999 14.7614 9.23856 17 12 17V15ZM8.99999 12C8.99999 10.3431 10.3431 9 12 9V7C9.23856 7 6.99999 9.23858 6.99999 12H8.99999ZM12 9C13.6568 9 15 10.3431 15 12H17C17 9.23858 14.7614 7 12 7V9ZM2.00018 13H7.99999V11H2.00018V13ZM16 13H22V11H16V13Z" }))));
};
exports.default = GitCommit;
